import HeaderBack from "@/components/fragments/HeaderBack";
import CustomerFeature from "@/features/Customer";

export default function Customer() {
  return (
    <div className="md:w-[80vw] lg:w-[70vw] mx-auto h-screen">
      <HeaderBack text="List Customer" url="/home" />

      <CustomerFeature />
    </div>
  );
}
